/* ==========================================================================
   Vildblad 2026 – fraktlinjen, förslag i varukorgen och fraktraden vid köpknappen.
   Bygger på theme.js (window.Vildblad) och ändrar inget i den.
   ========================================================================== */
(() => {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const formatMoney = (cents) => {
    const fmt = (window.Vildblad && window.Vildblad.moneyFormat) || '{{amount_no_decimals}} kr';
    const group = (n, sep) => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    const whole = Math.round(cents / 100);
    const dec = (cents / 100).toFixed(2).split('.');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount': return `${group(dec[0], ',')}.${dec[1]}`;
        case 'amount_with_comma_separator': return `${group(dec[0], '.')},${dec[1]}`;
        case 'amount_no_decimals_with_comma_separator': return group(whole, '.');
        case 'amount_no_decimals_with_space_separator': return group(whole, ' ');
        case 'amount_with_space_separator': return `${group(dec[0], ' ')},${dec[1]}`;
        default: return group(whole, ',');
      }
    });
  };

  /* ---------- Fraktlinjen: åk från förra läget till det nya ---------- */
  const lastPct = { drawer: null, page: null };
  let lastRender = 0;

  function animate(line, from, to) {
    if (reduceMotion || from === to) return;
    line.style.setProperty('--pct', from);
    void line.offsetWidth;
    setTimeout(() => {
      line.style.setProperty('--pct', to);
      if (from < 100 && to >= 100) line.classList.add('is-celebrating');
    }, 180);
  }

  /* ---------- "Handla för X kr till" vid köpknappen ---------- */
  function updateHints(total, count) {
    $$('[data-ship-hint]').forEach((el) => {
      const left = (parseInt(el.dataset.threshold, 10) || 0) - total;
      el.hidden = !count;
      el.classList.toggle('is-free', left <= 0);
      const amount = $('[data-ship-hint-amount]', el);
      if (amount && left > 0) amount.textContent = formatMoney(left);
      const l = $('[data-ship-hint-left]', el); if (l) l.hidden = left <= 0;
      const f = $('[data-ship-hint-free]', el); if (f) f.hidden = left > 0;
    });
  }

  function sync() {
    $$('[data-ship-line]:not([data-seen])').forEach((line) => {
      line.setAttribute('data-seen', '');
      const key = line.closest('[data-cart-drawer]') ? 'drawer' : 'page';
      const to = parseFloat(line.dataset.pct) || 0;
      const from = lastPct[key];
      lastPct[key] = to;
      if (from !== null) {
        lastRender = Date.now();
        animate(line, from, to);
        updateHints(parseInt(line.dataset.total, 10) || 0, parseInt(line.dataset.count, 10) || 0);
      }
    });
  }

  if ('MutationObserver' in window) {
    new MutationObserver(sync).observe(document.body, { childList: true, subtree: true });
  }
  sync();

  // Öppnas lådan från varukorgsikonen fylls linjen på från noll
  document.addEventListener('drawer:open', (e) => {
    if (!e.target || e.target.id !== 'CartDrawer') return;
    if (Date.now() - lastRender < 800) return;
    const line = $('#CartDrawer [data-ship-line]');
    if (line) animate(line, 0, parseFloat(line.dataset.pct) || 0);
  });

  /* ---------- Förslag i varukorgen: byt variant på knappen ---------- */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest && e.target.closest('[data-upsell-select]');
    if (!sel) return;
    const card = sel.closest('[data-upsell-card]');
    const opt = sel.selectedOptions[0];
    const btn = card && $('[data-quick-add]', card);
    if (btn && opt) btn.dataset.quickAdd = opt.value;
    const price = card && $('[data-upsell-price]', card);
    if (price && opt && opt.dataset.price) price.textContent = opt.dataset.price;
  });
})();